/* ============================================
   Pagination (infinite scroll)
   ============================================ */

(function () {
    'use strict';

    var feed = document.querySelector('.pg-feed');
    var nextLink = document.querySelector('link[rel="next"]');
    if (!feed || !nextLink) return;

    var loading = false;

    var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !loading) {
            loadMore();
        }
    }, {
        rootMargin: '200px'
    });

    // Create sentinel element
    var sentinel = document.createElement('div');
    sentinel.className = 'pg-load-sentinel';
    feed.parentElement.insertBefore(sentinel, feed.nextSibling);
    observer.observe(sentinel);

    function loadMore() {
        var url = nextLink && nextLink.getAttribute('href');
        if (!url) {
            observer.disconnect();
            return;
        }

        loading = true;

        fetch(url)
            .then(function (res) { return res.text(); })
            .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');

                // Append new cards
                var newCards = doc.querySelectorAll('.pg-card');
                newCards.forEach(function (card) {
                    feed.appendChild(document.importNode(card, true));
                });

                // Update next link
                var newNext = doc.querySelector('link[rel="next"]');
                if (newNext) {
                    nextLink.setAttribute('href', newNext.getAttribute('href'));
                } else {
                    nextLink.remove();
                    nextLink = null;
                    observer.disconnect();
                }

                loading = false;
            })
            .catch(function () {
                loading = false;
            });
    }
})();
